// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_OzznK {
 position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  display:flex;
  flex-direction:column;
}


.pad_Capv3 {
  padding : 10px;
}
.header_fevV5 {
  padding : 10px 26px 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom:5px solid var( --background );/*var( --border-color );*/

}

.noItems_hjcUA {
  text-align: left;
  padding : 20px 20px;
}

.leftIcon__N_3b {
  font-size : 24px;
  padding : 10px;
  color : #000;
}

.indicator_QvBaP {

}

@keyframes pulsate_MSpxm {
  from { font-style: 14px; }
  to { font-size:18px; }
}

.status-started_eR_W6 {
  NOanimation-name:pulsate_MSpxm;
  animation-duration: 0.5s;
  animation-direction: alternate-reverse;
  animation-iteration-count: infinite;
}

.screen_f5dwg .addSystem_N6e_I {
  border-radius:50%;
  width : 40px;
  height : 40px;
}


.count_Vn5nY {
  color : var( --light-grey );
  font-size:11px;
  padding-left: var( --size-padMedium, 8px);
}

.left_ZXJdp {
  position : absolute;
  top : 0;
  bottom : 0;
  right : 0;
  left : 0;
  min-width : 400px;

  .pagination_k96Ve { 
    border-top : 1px solid var( --lighter-grey );
    background: white;
    position:absolute;
    bottom : 0;
    margin : 0;
    height : 40px;
    width : 100%;
    display: flex;
    justify-content:center;
    align-items:center;


    .innerPagination_NQsa4 {
      margin : 0
    }

  }

  .list_WZHTg {
    position:absolute;
    width:100%;
    top : 0;
    bottom : 40px;
  }
}

.right_FbtuY { 
  position :relative;
  height:100%;
  overflow-y:auto;
  background:white;
}

.contactHeader_E3vYa {
  padding : 10px;
  text-align:right;
  display:flex;
  flex-direction:column;
  justify-content:stretch;
  align-items:flex-start;
}

.contactEntry_Sed_A {
  width : 100%;
  padding : 10px;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
}



.loading_jUWfs {
  color : var( --pink );
  font-size : var( --font-size-large );
  position:absolute;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  width : 100%;
  height: 100%;
  background : rgb( 255,255,255,0.6);
  div { 
    margin : 10px
  }
}


.screen_f5dwg .table_fUzGu {
  position: absolute;
  top: 0;
  max-height: 100%;
  left: 0;
  right: 0;
  bottom:0; /* need this for safari!! 8( */
}

.screen_f5dwg .table_fUzGu.empty_S1wYB {
  bottom: 0;
}
.screen_f5dwg .table_fUzGu .rt-tr-group {
  max-height: 50px;
  font-size: 12px;
  text-align: center;
}

.screen_f5dwg .table_fUzGu .rt-tr-group .rt-tr {
  align-items: center;
}
.screen_f5dwg .table_fUzGu .rt-tr-group .rt-td {

  overflow: visible;
}

.cellDropdown_UFL6M .span_JJLSH {
  display:none;
}

.typePopupTitle_KGksX.win_S8rwr {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.typePopupTitle_KGksX > *:not(:last-child) {
  margin-right : 8px;
}

.typePopup_pXZbx.win_S8rwr:not(div) {
  border: none;
  border-bottom: 5px solid transparent;
}
.typePopup_pXZbx.win_S8rwr:not(div):hover {
  border: none;
  border-bottom: 5px solid #ddd;
  background-color: #eee;
}
.typePopup_pXZbx.win_S8rwr:not(div)[data-value=true] {
  background-color: #ddd;
}
.typePopup_pXZbx.win_S8rwr:not(div):active[data-value=true] {
  color: white;
}
.typePopup_pXZbx.win_S8rwr:not(div):active[data-value=false], .typePopup_pXZbx.win_S8rwr:not(div):focus[data-value=false] {
  color: #7e7e7e;
}
.typePopup_pXZbx.win_S8rwr:not(div):hover[data-value=false] {
  color: white;
}
.typePopup_pXZbx.win_S8rwr {
  color: #7e7e7e;
  padding: 10px 15px;
  border-radius: 0;
  margin-bottom: -5px;
  line-height: 1.42857143;
  font-size: 16px;
}

.moltenImage_uB8ps {
  width : 24px;
  height : 24px;
}`, "",{"version":3,"sources":["webpack://./src/screens/system/style.css"],"names":[],"mappings":"AAEA;CACC,iBAAiB;EAChB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;;;AAGA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C,CAAC,yBAAyB;;AAEvE;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;;AAEA;;AAEA;EACE,OAAO,gBAAgB,EAAE;EACzB,KAAK,cAAc,EAAE;AACvB;;AAEA;EACE,8BAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE,2BAA2B;EAC3B,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,SAAS;EACT,QAAQ;EACR,iBAAiB;;EAEjB;IACE,4CAA4C;IAC5C,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;;;IAGlB;MACE;IACF;;EAEF;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,OAAO;IACP,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;;;AAIA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC;IACE;EACF;AACF;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,QAAQ,EAAE,8BAA8B;AAC1C;;AAEA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":["@import \"../../style/theme.css\";\n\n.content {\n position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  display:flex;\n  flex-direction:column;\n}\n\n\n.pad {\n  padding : 10px;\n}\n.header {\n  padding : 10px 26px 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom:5px solid var( --background );/*var( --border-color );*/\n\n}\n\n.noItems {\n  text-align: left;\n  padding : 20px 20px;\n}\n\n.leftIcon {\n  font-size : 24px;\n  padding : 10px;\n  color : #000;\n}\n\n.indicator {\n\n}\n\n@keyframes pulsate {\n  from { font-style: 14px; }\n  to { font-size:18px; }\n}\n\n.status-started {\n  NOanimation-name:pulsate;\n  animation-duration: 0.5s;\n  animation-direction: alternate-reverse;\n  animation-iteration-count: infinite;\n}\n\n.screen .addSystem {\n  border-radius:50%;\n  width : 40px;\n  height : 40px;\n}\n\n\n.count {\n  color : var( --light-grey );\n  font-size:11px;\n  padding-left: var( --size-padMedium, 8px);\n}\n\n.left {\n  position : absolute;\n  top : 0;\n  bottom : 0;\n  right : 0;\n  left : 0;\n  min-width : 400px;\n\n  .pagination { \n    border-top : 1px solid var( --lighter-grey );\n    background: white;\n    position:absolute;\n    bottom : 0;\n    margin : 0;\n    height : 40px;\n    width : 100%;\n    display: flex;\n    justify-content:center;\n    align-items:center;\n\n\n    .innerPagination {\n      margin : 0\n    }\n\n  }\n\n  .list {\n    position:absolute;\n    width:100%;\n    top : 0;\n    bottom : 40px;\n  }\n}\n\n.right { \n  position :relative;\n  height:100%;\n  overflow-y:auto;\n  background:white;\n}\n\n.contactHeader {\n  padding : 10px;\n  text-align:right;\n  display:flex;\n  flex-direction:column;\n  justify-content:stretch;\n  align-items:flex-start;\n}\n\n.contactEntry {\n  width : 100%;\n  padding : 10px;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n}\n\n\n\n.loading {\n  color : var( --pink );\n  font-size : var( --font-size-large );\n  position:absolute;\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  width : 100%;\n  height: 100%;\n  background : rgb( 255,255,255,0.6);\n  div { \n    margin : 10px\n  }\n}\n\n\n.screen .table {\n  position: absolute;\n  top: 0;\n  max-height: 100%;\n  left: 0;\n  right: 0;\n  bottom:0; /* need this for safari!! 8( */\n}\n\n.screen .table.empty {\n  bottom: 0;\n}\n.screen .table :global(.rt-tr-group) {\n  max-height: 50px;\n  font-size: 12px;\n  text-align: center;\n}\n\n.screen .table :global(.rt-tr-group) :global(.rt-tr) {\n  align-items: center;\n}\n.screen .table :global(.rt-tr-group) :global(.rt-td) {\n\n  overflow: visible;\n}\n\n.cellDropdown .span {\n  display:none;\n}\n\n.typePopupTitle.win {\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.typePopupTitle > *:not(:last-child) {\n  margin-right : 8px;\n}\n\n.typePopup.win:not(div) {\n  border: none;\n  border-bottom: 5px solid transparent;\n}\n.typePopup.win:not(div):hover {\n  border: none;\n  border-bottom: 5px solid #ddd;\n  background-color: #eee;\n}\n.typePopup.win:not(div)[data-value=true] {\n  background-color: #ddd;\n}\n.typePopup.win:not(div):active[data-value=true] {\n  color: white;\n}\n.typePopup.win:not(div):active[data-value=false], .typePopup.win:not(div):focus[data-value=false] {\n  color: #7e7e7e;\n}\n.typePopup.win:not(div):hover[data-value=false] {\n  color: white;\n}\n.typePopup.win {\n  color: #7e7e7e;\n  padding: 10px 15px;\n  border-radius: 0;\n  margin-bottom: -5px;\n  line-height: 1.42857143;\n  font-size: 16px;\n}\n\n.moltenImage {\n  width : 24px;\n  height : 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_OzznK`,
	"pad": `pad_Capv3`,
	"header": `header_fevV5`,
	"noItems": `noItems_hjcUA`,
	"leftIcon": `leftIcon__N_3b`,
	"indicator": `indicator_QvBaP`,
	"status-started": `status-started_eR_W6`,
	"pulsate": `pulsate_MSpxm`,
	"screen": `screen_f5dwg`,
	"addSystem": `addSystem_N6e_I`,
	"count": `count_Vn5nY`,
	"left": `left_ZXJdp`,
	"pagination": `pagination_k96Ve`,
	"innerPagination": `innerPagination_NQsa4`,
	"list": `list_WZHTg`,
	"right": `right_FbtuY`,
	"contactHeader": `contactHeader_E3vYa`,
	"contactEntry": `contactEntry_Sed_A`,
	"loading": `loading_jUWfs`,
	"table": `table_fUzGu`,
	"empty": `empty_S1wYB`,
	"cellDropdown": `cellDropdown_UFL6M`,
	"span": `span_JJLSH`,
	"typePopupTitle": `typePopupTitle_KGksX`,
	"win": `win_S8rwr`,
	"typePopup": `typePopup_pXZbx`,
	"moltenImage": `moltenImage_uB8ps`
};
export default ___CSS_LOADER_EXPORT___;
